<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
    ></search-form>
    <a-modal
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :disabled="true"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.carBlackWhiteList?.type, Enum.blackWhiteListType.value) }}
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="ableCheck && record.carBlackWhiteList.status === 1"
            >
              审核
            </a-button>
          </span>
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData, revoke } from '@/api/black_white_list/car_list_approval'
  import action from './action'
  import { message } from 'ant-design-vue'
  import searchForm from '@/components/search_form'
  import { codeToText, constantToOptions } from '@/utils/format'
  import { approvalOperation } from '@/utils/common'
  import table_data_format from '@/components/table_data_format'
  //初始化
  const pageName = '车辆黑白名单审核'
  const idField = 'process_task_id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carListApproval:list')
  )
  const ableCheck = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carListApproval:check')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'licensePlate',
      label: '车牌号码',
    },
    {
      type: 'select',
      field: 'type',
      storeOptions: 'blackWhiteListType',
      filterNegative: true,
      // defaultValue: 1,
      label: '名单类型',
      width: '130px',
      'allow-clear': true,
    },
    // {
    //   type: 'select',
    //   field: 'operation',
    //   options: constantToOptions(approvalOperation),
    //   label: '审核类型',
    //   // defaultValue: 0,
    //   'allow-clear': true,
    //   width: '130px',
    // },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setBlackCarApproval', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      dataInObject: 'carBlackWhiteList',
      align: 'left',
    },
    {
      title: '车型',
      key: 'vehicle_type_id',
      dataInObject: 'carBlackWhiteList',
      align: 'left',
    },
    {
      title: '名单类型',
      key: 'type',
      dataIndex: 'type',
      dataInObject: 'carBlackWhiteList',
      storeOptions: 'blackWhiteListType',
      align: 'left',
    },
    {
      title: '时间范围',
      key: 'time_range',
      dataInObject: 'carBlackWhiteList',

      align: 'left',
    },
    {
      title: '审核状态',
      key: 'status',
      dataInObject: 'carBlackWhiteList',

      align: 'left',
    },
    {
      title: '原因备注',
      dataIndex: 'in_reason',
      key: 'in_reason',
      dataInObject: 'carBlackWhiteList',
      align: 'left',
    },
    {
      title: '提交人',
      dataIndex: 'create_user_id',
      key: 'create_user_id',
      dataInObject: 'carBlackWhiteList',
      align: 'left',
    },
    {
      title: '提交审核时间',
      dataIndex: 'submit_time',
      key: 'submit_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '120px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchBlackCarApproval)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、审核
  const open = ref(false)
  const isEdit = ref(true)
  const editData = ref(null)
  const showEditModal = (data) => {
    editData.value = data
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showEditModal(record);
      }
    }
  }

  //4、撤销审核
  async function delRow(data) {
    const res = await revoke({ id: data[idField] })
    if (res.success) {
      message.success('撤销审核成功！')
      fetch()
    } else {
      message.warn('撤销审核失败' + res.message)
    }
  }
</script>
